import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "xml",
  "name": "XML",
  "category": "utilities",
  "description": "Parse and generate XML data",
  "icon": "FileCode",
  "color": "gray",
  "version": "1.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "XML",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "xml",
    "parse",
    "convert",
    "format"
  ]
};

export default definition;
